export enum ErrorCodesEnum {
  No = '0',
  OrganizerSharedActivityMandatoryFields = '1',
  OrganizerSharedOrganizationMandatoryFields = '2',
  OrganizerSharedGetActivityByQueryId = '3',
  OrganizerSharedHasActivity = '4',
  OrganizerSharedGetOrganizationByQueryId = '5',
  OrganizerSharedGetOrganizationFromAuthUser = '6',
  OrganizerSharedHasOrganization = '7',
  OrganizerSharedIsAuthorizedRedirectUrl = '8',
  AuthDenyProviders = '9',
  AuthAllowProviders = '10',
  OrganizerSharedOrganizationHasPaymentForPayingActivity = '11',
  OnboardingGetOrganizationFromAuthUserGuard = '12',
  OnboardingOrganizationHasStoreNumberGuard = '13',
  OnboardingOrganizationHasProfileGuard = '14',
}
